import { inject, Injectable } from '@angular/core';
import { FlyoutFooter } from '@com-delta-idp/mnx-capability-flyout-ui';
import {
  HeaderFooterMachCore,
  LogoutService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { BehaviorSubject } from 'rxjs';
import { FlyoutFooterAdapterService } from '../../adapters/footer/flyout-footer-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class FlyoutFooterFacadeService {
  flyoutFooterDetails$ = new BehaviorSubject<FlyoutFooter>({} as FlyoutFooter);
  adapter = inject(FlyoutFooterAdapterService);
  logOut = inject(LogoutService);

  init(content: HeaderFooterMachCore): void {
    this.flyoutFooterDetails$.next(this.adapter.getContent(content));
  }

  logout(): void {
    this.logOut.logOut();
  }
}
